import { createContext, useContext, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const AudioCtx = createContext({ playing: false, toggle: () => {} });
export const useAudio = () => useContext(AudioCtx);

export function AudioProvider({ children }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  // Background music is strictly opt-in: it plays only when the visitor
  // clicks the speaker button — never automatically on page entry.
  const toggle = async () => {
    const el = audioRef.current;
    if (!el) return;
    if (el.paused) {
      el.volume = 0.35;
      await el.play();
      setPlaying(true);
    } else {
      el.pause();
      setPlaying(false);
    }
  };

  return (
    <AudioCtx.Provider value={{ playing, toggle }}>
      {children}
      <audio ref={audioRef} src="/audio/pure-clarity.mp3" preload="none" data-testid="background-audio" />
    </AudioCtx.Provider>
  );
}

export const AudioToggle = ({ testId = "audio-toggle" }) => {
  const { playing, toggle } = useAudio();
  return (
    <button
      onClick={toggle}
      data-testid={testId}
      aria-label={playing ? "Mute background music" : "Play background music"}
      title={playing ? "Music: Pure Clarity — on" : "Play background music"}
      className={`inline-flex h-9 w-9 items-center justify-center border transition-colors duration-300 ${
        playing
          ? "border-[#0e8c8c] text-[#0e8c8c]"
          : "border-[#e4e9ec] text-[#56636b] hover:border-[#0a0a0a] hover:text-[#0a0a0a]"
      }`}
    >
      {playing ? <Volume2 className="h-4 w-4" data-testid="audio-playing-icon" /> : <VolumeX className="h-4 w-4" />}
    </button>
  );
};

export default AudioProvider;
